import isAdmin from 'Services/me';

export default function ShowAdmin({ children }) {
  return isAdmin() ? children : null;
}
